var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15C8F117-0564-4757-B0E3-7EC85C9BAADA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.98752,7.26516222 L12.6334507,7.26516222 L12.6334507,5.62453799 C12.6334507,2.59007803 10.2011467,0.0552197125 7.161056,0.00110882957 C7.07798933,-0.000369609856 6.91200533,-0.000369609856 6.828976,0.00110882957 C3.78881067,0.0552197125 1.356544,2.59007803 1.356544,5.62453799 L1.356544,7.26516222 L1.00243733,7.26516222 C0.456773333,7.26516222 0.0116853333,7.8226078 0.0116853333,8.51108008 L0.0116853333,16.7397782 C0.0116853333,17.4274743 0.456773333,17.9901314 1.00247467,17.9901314 L12.98752,17.9901314 C13.533184,17.9901314 13.9783093,17.4274743 13.9783093,16.7397782 L13.9783093,8.51108008 C13.9783093,7.82264476 13.5332213,7.26516222 12.98752,7.26516222 Z M8.11783467,12.617076 L8.11783467,15.1034784 C8.11783467,15.3881889 7.877072,15.6291376 7.58926933,15.6291376 L6.4008,15.6291376 C6.11296,15.6291376 5.87219733,15.3881889 5.87219733,15.1034784 L5.87219733,12.617076 C5.593056,12.3450431 5.430544,11.9688912 5.430544,11.5527844 C5.430544,10.7642587 6.046208,10.0866899 6.82901333,10.055384 C6.911968,10.0520575 7.07813867,10.0520575 7.16109333,10.055384 C7.94389867,10.0866899 8.55956267,10.7642587 8.55956267,11.5527844 C8.559488,11.9688912 8.396976,12.3450431 8.11783467,12.617076 Z M10.2997813,7.26516222 L7.161056,7.26516222 L6.828976,7.26516222 L3.690288,7.26516222 L3.690288,5.62453799 C3.690288,3.81696099 5.174064,2.32236961 6.99499733,2.32236961 C8.81593067,2.32236961 10.2997813,3.81696099 10.2997813,5.62453799 L10.2997813,7.26516222 Z",
    id: "path-lock"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16E55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C00000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web->-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login---Sorting/T2P",
    transform: "translate(-313.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Div---Form",
    transform: "translate(262.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form",
    transform: "translate(33.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password",
    transform: "translate(0.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password-Icon",
    transform: "translate(18.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-lock",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-lock"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-lock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8Color",
    mask: "url(#mask-lock)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gradient",
    x: 0,
    y: 0,
    width: 14,
    height: 18
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.15795a8d6fe8ad5f5e47ae4d738368c3.svg";
export { ForwardRef as ReactComponent };